import { render, staticRenderFns } from "./StockchartMenu.vue?vue&type=template&id=18bd817f&scoped=true&"
import script from "./StockchartMenu.vue?vue&type=script&lang=js&"
export * from "./StockchartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StockchartMenu.vue?vue&type=style&index=0&id=18bd817f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd817f",
  null
  
)

export default component.exports